import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function LinkedIn(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.041 17.042h-2.963v-4.64c0-1.108-.022-2.531-1.542-2.531-1.544 0-1.78 1.205-1.78 2.45v4.721H7.794V7.498h2.844v1.304h.04c.396-.75 1.364-1.542 2.807-1.542 3.001 0 3.556 1.977 3.556 4.547v5.235zM4.45 6.193a1.72 1.72 0 11-.003-3.439 1.72 1.72 0 01.003 3.44zm-1.485 10.85h2.969V7.497h-2.97v9.544zM18.518 0H1.476C.662 0 0 .646 0 1.441v17.116C0 19.354.662 20 1.475 20h17.044c.815 0 1.481-.646 1.481-1.443V1.441C20 .646 19.334 0 18.518 0z",
    clipRule: "evenodd"
  }));
}

export { LinkedIn };
//# sourceMappingURL=LinkedIn.js.map